import React from 'react';
import { useSlotScreenGeneratorStore } from '@store/slotScreenGeneratorStore';
import { ScreenSidebar } from './ScreenSidebar';
import { ScreenCanvas } from './ScreenCanvas';
import { ComponentListStrip } from './ComponentListStrip';
import { ComponentGeneratorView } from './ComponentGeneratorView';
import { useRestoreComponentImages } from '@hooks/useRestoreComponentImages';

export function ScreenBuilderTab() {
  // Restore saved component images on mount
  useRestoreComponentImages();

  const generatorComponentId = useSlotScreenGeneratorStore(s => s.generatorViewComponentId);

  // If a component's generator view is open, show it full-panel
  if (generatorComponentId) {
    return <ComponentGeneratorView />;
  }

  // Otherwise show the canvas view with sidebar + canvas + component strip
  return (
    <div className="flex flex-1 overflow-hidden">
      <ScreenSidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <ScreenCanvas />
        <ComponentListStrip />
      </div>
    </div>
  );
}
